import { useNavigate, useParams } from 'react-router-dom';

import './oldbtn.css';

 
/* ── ICONS ── */
const IcoClock = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 8 14"/>
  </svg>
);
const IcoArrowLeft = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12"/>
    <polyline points="12 19 5 12 12 5"/>
  </svg>
);
 
/* ════════════════════════════════════════════════════════
   COMPONENT — misma lógica que NewVersionButton
════════════════════════════════════════════════════════ */
export default function PreviousVersionButton({ route }) {
  const navigate = useNavigate();
  const { business_code } = useParams();
 
  const handleClick = () => {
    if (!route) return;
    navigate(`/${route}/${business_code}`);
  };
 
  return (
    <div className="pvb-wrap">
 
      {/* Botón */}
      <button className="pvb-btn" onClick={handleClick} type="button">
 
        {/* Flecha ← */}
        <span className="pvb-arrow" aria-hidden="true">
          <IcoArrowLeft />
        </span>
 
        {/* Ícono reloj */}
        <span className="pvb-ico" aria-hidden="true">
          <IcoClock />
        </span>
 
        {/* Texto */}
        <span className="pvb-label">
          <span className="pvb-label-top">Regresar a la</span>
          <span className="pvb-label-main">Versión anterior</span>
        </span>
 
      </button>
    </div>
  );
}